// Google Ads Purchase Conversion Tracking for Shopify with Consent Check
document.addEventListener('visitorConsentCollected', function(event) {
  if (event.detail.analyticsAllowed || event.detail.marketingAllowed) {
    (function() {
      'use strict';
      
      // Only run on checkout pages or order confirmation
      if (typeof Shopify === 'undefined' || 
          (!window.location.pathname.includes('thank_you') && 
           !window.location.pathname.includes('orders') &&
           !document.body.classList.contains('order-status-page'))) {
        return;
      }
      
      // Get order data from Shopify checkout object if available
      let orderData = {};
      
      if (typeof Shopify.checkout !== 'undefined') {
        orderData = {
          order_id: Shopify.checkout.order_id,
          order_number: Shopify.checkout.order_number,
          total_price: Shopify.checkout.total_price,
          currency: Shopify.checkout.currency
        };
      } else {
        // Try to get data from URL params or other sources
        const urlParams = new URLSearchParams(window.location.search);
        orderData = {
          order_id: urlParams.get('order_id') || '',
          order_number: urlParams.get('order_number') || '',
          total_price: parseFloat(urlParams.get('total_price') || '0'),
          currency: urlParams.get('currency') || 'USD'
        };
      }
      
      // Only fire if we have order data and haven't fired already
      if (orderData.order_id && orderData.total_price > 0) {
        const storageKey = 'google_ads_purchase_fired_' + orderData.order_number;
        
        if (!sessionStorage.getItem(storageKey)) {
          
          // Wait for gtag to be available
          function fireConversion() {
            if (typeof gtag === 'function') {
              gtag('event', 'conversion', {
                'send_to': 'AW-955232139/PURCHASE_CONVERSION_LABEL', // Replace with actual label
                'value': orderData.total_price / 100, // Convert cents to dollars
                'currency': orderData.currency,
                'transaction_id': orderData.order_number,
                'custom_parameters': {
                  'order_id': orderData.order_id
                }
              });
              
              // Mark as fired to prevent duplicates
              sessionStorage.setItem(storageKey, 'true');
              console.log('Google Ads purchase conversion fired for order:', orderData.order_number);
              
            } else {
              // Retry after 100ms if gtag isn't ready yet
              setTimeout(fireConversion, 100);
            }
          }
          
          // Fire conversion after a small delay to ensure everything is loaded
          setTimeout(fireConversion, 500);
        }
      }
      
    })();
  }
});